export const CARD_SURFACE =
    'cmp-card-pad-md rounded-2xl border border-white bg-white/60 backdrop-blur-md';
